import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import ChatwootHint from '../ChatwootHint';
import {
 CircleMenuBlock,
 CircleButton,
 SocialList,
 SocialListItem,
 Max,
 Chat,
} from './CircleMenu.styled';
import Cookies from 'js-cookie';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { openChatWoot } from '../../../store/reducers/openChatWootSlice';

declare const window: any;

const CircleMenu = () => {
 const [active, setActive] = useState(false);
 const [opened, setOpened] = useState(false);
 const [chatwootHint, setChatwootHint] = useState(false);

 const location = useLocation();
 const dispatch = useDispatch<AppDispatch>();

 const openChatWootData = useSelector(
  (state: RootState) => state.openChatWoot,
  shallowEqual,
 );

 const isMainPage = location.pathname === '/';
 const isMobile = localStorage.mobile || window.navigator.maxTouchPoints > 1;

 const addClass = () => {
  setActive(!active);
  setOpened(!opened);
  setChatwootHint(false);
  if (active) window.$chatwoot?.toggle('close');
  dispatch(openChatWoot(null));
 };

 const openChat = () => {
  window.$chatwoot?.toggle();
 };

 useEffect(() => {
  if (openChatWootData) {
   openChat();
   setActive(true);
   setOpened(true);
   window.$chatwoot?.toggle('open');
  }
 }, [openChatWootData]);

 useEffect(() => {
  if (!isMainPage) {
   setActive(false);
   setOpened(false);

   return;
  }

  const firstOpen = Cookies.get('firstOpenChat');
  if (isMobile) {
   if (firstOpen !== 'firstOpen') {
    setChatwootHint(true);
    Cookies.set('firstOpenChat', 'firstOpen');
   } else {
    setChatwootHint(false);
   }
  } else if (firstOpen !== 'firstOpen') {
   window.addEventListener('chatwoot:ready', function () {
    const timeout = setTimeout(() => {
     setActive(true);
     setOpened(true);
     window.$chatwoot?.toggle('open');
    }, 3000);
    Cookies.set('firstOpenChat', 'firstOpen');
    return () => clearTimeout(timeout);
   });
  } else {
   return;
  }
 }, [isMainPage, isMobile]);

 return (
  <>
   <ChatwootHint opened={chatwootHint} setOpened={setChatwootHint} />
   <CircleMenuBlock>
    <CircleButton
     active={active}
     onClick={addClass}
     type="button"
     id="widg"
    ></CircleButton>
    <SocialList>
     {/* <SocialListItem className="circle-menu__item telegram" opened={opened}>
      <Viber
       opened={opened}
       href="viber://pa?chatURI=vostokchatsbot "
       title="viber"
      ></Viber>
     </SocialListItem> */}
     <SocialListItem
      style={{ width: '40px', height: '40px', zIndex: 10000 }}
      className="circle-menu__item vkontakte"
      opened={opened}
     >
      <Max
       opened={opened}
       href="https://max.ru/id7705424509_2_bot"
       title="МАКС"
      ></Max>
     </SocialListItem>
     <SocialListItem onClick={openChat} opened={opened} title="chat">
      <Chat opened={opened}></Chat>
     </SocialListItem>
    </SocialList>
   </CircleMenuBlock>
  </>
 );
};

export default CircleMenu;
